import type { ReactNode } from "react";
import { Alert } from "@mui/material";

/** データが無いことを伝える情報アラート */
export const EmptyAlert: React.FC<{ children: ReactNode }> = ({ children }) => (
  <Alert severity="info">{children}</Alert>
);
